// extracted by mini-css-extract-plugin
export default {"picker":"RelationTypePicker_picker__MhGqP"};